#import "../fragments/meeting-fragment.graphql"

mutation UndeleteMeeting($input: MeetingUndeleteInput!) {
    meetingUndelete(input: $input) {
        meeting {
            ...MeetingFragment
        }
    }
}
